import { Phrase } from 'components/Phrase';

import {
  ClipboardSvg,
  Container,
  Description,
  Header,
  HorizontalLine,
  Instructions,
  InstructionsContainer,
  Phone,
  SubHeader,
} from './styles';

export const CarouselItemScheduleMaintenanceNoTimeSlotsTop = () => (
  <Container>
    <Header>
      <Phrase id="SCHEDULE_MAINTENANCE.NO_AVAILABILITY.HEADER" />
    </Header>
    <SubHeader>
      <Phrase id="SCHEDULE_MAINTENANCE.NO_AVAILABILITY.SUBHEAD" />
    </SubHeader>
    <Description>
      <Phrase id="SCHEDULE_MAINTENANCE.NO_AVAILABILITY.DESCRIPTION" />
    </Description>
    <InstructionsContainer>
      <ClipboardSvg />
      <Instructions>
        <Phrase id="SCHEDULE_MAINTENANCE.NO_AVAILABILITY.INSTRUCTION" />
      </Instructions>
    </InstructionsContainer>
    <HorizontalLine />
    <Phone>
      <Phrase id="PHONE_STYLIZED" />
    </Phone>
  </Container>
);
